module.exports = __webpack_public_path__ + "img/06.d47fab7a.png";